import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';

import { NewsletterResource } from 'app/models/NewsletterResource';

@Injectable()
export class UnsubscribeService {

  constructor(private http: HttpClient) { }

  getNewsletter(body): Observable<NewsletterResource> {
    return this.http.get<NewsletterResource>(body)
  }

  unsubscribe(body): Observable<NewsletterResource> {
    return this.http.get<NewsletterResource>(body)
  }

}
